export function getFileType(file) {
  const fileType = file?.type?.split("/")[1] ?? "";
  return fileType;
}
